import { render, staticRenderFns } from "./JdRankList.vue?vue&type=template&id=1bbf46e9&scoped=true&"
import script from "./JdRankList.vue?vue&type=script&lang=js&"
export * from "./JdRankList.vue?vue&type=script&lang=js&"
import style0 from "./JdRankList.vue?vue&type=style&index=0&id=1bbf46e9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf46e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/huangdie/work-gwdang/plt_web/template/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbf46e9')) {
      api.createRecord('1bbf46e9', component.options)
    } else {
      api.reload('1bbf46e9', component.options)
    }
    module.hot.accept("./JdRankList.vue?vue&type=template&id=1bbf46e9&scoped=true&", function () {
      api.rerender('1bbf46e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "metro/components/JdRankList.vue"
export default component.exports